import { Divider, Group, Select, Stack, Text, TextInput } from "@mantine/core";
import { clone } from "ramda";
import React from "react";
import { IGeoTeknikkRapport } from "@mcapps/shared/reportSchemas/geoteknikSchema";
import { dividerWeight, labelWeight } from "../reportBoardConstants";

const GeoteknikGenrellInfo: React.FC<{
  editData: IGeoTeknikkRapport;
  updateData: (key: string, value: any) => void;
}> = ({ editData, updateData }) => {
  return (
    <Stack gap="xs">
      <Divider
        label={
          <Text fz="lg" fw={dividerWeight}>
            Generelt
          </Text>
        }
        labelPosition="center"
        mb="xs"
      />

      <Group grow>
        <Text fw={labelWeight}>1.1 Oppdragsnavn:</Text>
        <TextInput
          required
          size="sm"
          value={editData.generellInfo?.oppdragsNavn}
          onChange={(e) => updateData("generellInfo.oppdragsNavn", e.target.value)}
        />
      </Group>

      <Group grow>
        <Text fw={labelWeight}>1.2 Oppdragsnummer:</Text>
        <TextInput
          required
          size="sm"
          value={editData.generellInfo?.oppdragsNummer}
          onChange={(e) => updateData("generellInfo.oppdragsNummer", e.target.value)}
        />
      </Group>

      <Group grow>
        <Text fw={labelWeight}>1.3 Oppdragsgiver:</Text>
        <TextInput
          size="sm"
          value={editData.generellInfo?.oppdragsGiver?.navn}
          onChange={(e) => updateData("generellInfo.oppdragsGiver.navn", e.target.value)}
        />
      </Group>

      <Group grow>
        <Text fw={labelWeight}>1.4 Oppdragsleder:</Text>
        <TextInput
          size="sm"
          value={editData.generellInfo?.oppdragsLeder}
          onChange={(e) => updateData("generellInfo.oppdragsLeder", e.target.value)}
        />
      </Group>

      <Group grow>
        <Text fw={labelWeight}>1.5 Kontaktperson:</Text>
        <TextInput
          size="sm"
          value={editData.generellInfo?.oppdragsGiver?.kontaktPerson}
          onChange={(e) => updateData("generellInfo.oppdragsGiver.kontaktPerson", e.target.value)}
        />
      </Group>

      <Group grow>
        <Text fw={labelWeight}>1.6 Høydesystem:</Text>
        <TextInput
          size="sm"
          value={editData.prosjektInformasjon?.hoydeSystem}
          onChange={(e) => updateData("prosjektInformasjon.hoydeSystem", e.target.value)}
        />
      </Group>

      <Group align="center">
        <Text fw={labelWeight}>1.9 Eiendomsinformasjon</Text>
      </Group>

      <Group grow>
        <Text fw={labelWeight}>Gnr:</Text>
        <TextInput
          type="number"
          size="sm"
          value={editData.prosjektInformasjon?.eiendomsInformasjon?.gnr}
          onChange={(e) => updateData("prosjektInformasjon.eiendomsInformasjon.gnr", Number(e.target.value))}
        />
      </Group>

      <Group grow>
        <Text fw={labelWeight}>Bnr:</Text>
        <TextInput
          type="number"
          size="sm"
          value={editData.prosjektInformasjon?.eiendomsInformasjon?.bnr}
          onChange={(e) => updateData("prosjektInformasjon.eiendomsInformasjon.bnr", Number(e.target.value))}
        />
      </Group>

      <Group grow>
        <Text fw={labelWeight}>Snr:</Text>
        <TextInput
          type="number"
          size="sm"
          value={editData.prosjektInformasjon?.eiendomsInformasjon?.snr}
          onChange={(e) => updateData("prosjektInformasjon.eiendomsInformasjon.snr", Number(e.target.value))}
        />
      </Group>

      <Group grow>
        <Text fw={labelWeight}>By:</Text>
        <TextInput
          size="sm"
          value={editData.prosjektInformasjon?.eiendomsInformasjon?.by}
          onChange={(e) => updateData("prosjektInformasjon.eiendomsInformasjon.by", e.target.value)}
        />
      </Group>

      <Group grow>
        <Text fw={labelWeight}>1.10 Tilgjengelighet:</Text>
        <Select
          size="sm"
          data={["Åpen", "Begrenset", "Lukket"]}
          value={editData.prosjektInformasjon?.tilgjengelighet}
          onChange={(value) => updateData("prosjektInformasjon.tilgjengelighet", value)}
        />
      </Group>

      <Group grow>
        <Text fw={labelWeight}>1.11 Saksbehandler:</Text>
        <TextInput
          size="sm"
          value={editData.prosjektInformasjon?.saksbehandler}
          onChange={(e) => updateData("prosjektInformasjon.saksbehandler", e.target.value)}
        />
      </Group>

      <Group grow>
        <Text fw={labelWeight}>1.12 Ansvarlig enhet:</Text>
        <Select
          size="sm"
          data={clone(GEOTEKNIK_DEPARTMENTS)}
          value={editData.prosjektInformasjon?.ansvarligEnhet}
          onChange={(value) => updateData("prosjektInformasjon.ansvarligEnhet", value)}
        />
      </Group>
    </Stack>
  );
};

export default GeoteknikGenrellInfo;

export const GEOTEKNIK_DEPARTMENTS = [
  "-",
  "10232011 Geoteknikk Sør",
  "10233011 Geoteknikk Samferdsel og bygg Vest",
  "10233016 Geoteknikk Energi og Industri Vest",
  "10234011 Geoteknikk Samferdsel Midt",
  "10234015 Geoteknikk Bygg og Industri Midt",
  "10234016 Geoteknikk Naturfare Midt",
  "10235011 Geoteknikk Nord",
  "10235014 Grunnundersøkelser Nord",
  "10101010 Geoteknikk Industri og Energi Oslo",
  "10101020 Geoteknikk B&E Oslo",
  "10101080 Geoteknikk Samferdsel Oslo",
  "10101050 Grunnundersøkelser Oslo",
  "10112011 Geofag BVT",
  "10111063 Østfold",
];
